import { Button } from '@/components/primitives/Button';
import { Modal, ModalContent, ModalTitle } from '@/components/composites/Modal';

const ACCESS_RETRY_TITLE = "We couldn't check your membership.";
const ACCESS_RETRY_ACTION = 'Try again';

/**
 * Full-screen state for an access check the server could not answer. It
 * stands in for the screen (never the paywall), so a member is never locked
 * out, or let in, because of a network error.
 */
export function AccessRetryState({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      data-jp-core-access="error"
      className="flex min-h-screen items-center justify-center bg-jp-bg-page px-4 text-jp-fg-primary"
    >
      <div role="alert" className="flex max-w-sm flex-col items-center gap-5 text-center">
        <h1 className="font-jp-display text-2xl font-extrabold leading-tight">{ACCESS_RETRY_TITLE}</h1>
        <Button type="button" onClick={onRetry}>
          {ACCESS_RETRY_ACTION}
        </Button>
      </div>
    </div>
  );
}

/**
 * The same retry state as a dialog, for a page that stays on screen (a Start
 * button whose access check failed). Shown where the paywall would open.
 */
export function AccessRetryDialog({
  open,
  onOpenChange,
  onRetry,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRetry: () => void;
}) {
  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent size="sm" aria-describedby={undefined} data-jp-access-retry="error">
        <div className="flex flex-col items-center gap-5 pt-4 text-center">
          <ModalTitle className="font-jp-display text-2xl font-extrabold leading-tight">
            {ACCESS_RETRY_TITLE}
          </ModalTitle>
          <Button type="button" onClick={onRetry}>
            {ACCESS_RETRY_ACTION}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
